// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ResetPasswordState from "@store/Framework/Store/Greif/Pages/ResetPassword/ResetPasswordState";
import { Draft } from "immer";

const initialState: ResetPasswordState = {
    isSettingNewPassword: false,
};

const actions = {
    "Greif/Pages/ResetPassword/SetIsActivatingAccount": (
        draft: Draft<ResetPasswordState>,
        action: { isSettingNewPassword: boolean },
    ) => {
        draft.isSettingNewPassword = action.isSettingNewPassword;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifOrderResetPasswordPageActions = Parameters<typeof reducer>[1];
export default reducer;
